<template>
  <v-dialog
    ref="dialog"
    v-model="dialogOpened"
    transition="dialog-bottom-transition"
    fullscreen
    persistent
    no-click-animation
    hide-overlay
    :retain-focus="false"
    @keydown.esc="_back"
  >
    <v-card class="d-flex flex-column">
      <v-toolbar class="flex-grow-0" dark color="primary">
        <v-toolbar-title>Meine Räume</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="_back">
          <v-icon>fal fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="flex d-flex flex-column pt-4 px-4">
        <router-link
          v-ripple
          class="create-room bordered d-flex align-center justify-center py-4 px-4"
          :to="'/share/rooms/create'"
        >
          <v-icon class="mr-3">fal fa-plus</v-icon>
          <span>Neuen Raum erstellen</span>
        </router-link>

        <div v-if="loading" class="text-center py-4 px-4">
          <v-progress-circular
            :width="3"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>

        <v-alert v-if="error" type="error" class="mt-4" text>
          Räume konnten nicht geladen werden.
        </v-alert>

        <Room v-for="room in rooms" :key="room.id" :room="room" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import Dialog from './Dialog';
  import Room from '../rooms/Room';
  import eventBus from '../../assets/js/event-bus';
  import {routeOptions} from '../../assets/js/utils';


  export default {
    name: 'RoomsDialog',

    components: {
      Room
    },

    extends: Dialog,

    data() {
      return {
        data: [],
        loading: false,
        error: false,
        updating: null,
        // Dialog
        routePath: '/share/rooms'
      };
    },

    computed: {
      rooms() {
        const rooms = [...this.data];
        if (rooms?.length && this.$store.getters['share/getTour']?.exampleRoom) {
          rooms.splice(1, 0, {
            id: 'example-room',
            name: 'Beispielraum',
            description: '',
            owner: {
              name: 'Die Hilfe',
              online: true
            },
            participants: [],
            private: true
          });
        }
        return rooms;
      }
    },

    watch: {
      dialogOpened(opened) {
        if (opened) {
          this.loadData();
        } else {
          clearTimeout(this._onRooms_timeoutUpdated);
        }

      },

      data(rooms) {
        this.$emit('rooms', rooms);
      }
    },

    mounted() {
      eventBus.$on('roomsUpdated', this._onRoomsUpdated);
      eventBus.$on('roomDeleted', this._onRoomsUpdated);
      eventBus.$on('roomUpdated', this._onRoomsUpdated);
    },

    destroyed() {
      eventBus.$off('roomsUpdated', this._onRoomsUpdated);
      eventBus.$off('roomDeleted', this._onRoomsUpdated);
      eventBus.$off('roomUpdated', this._onRoomsUpdated);
    },

    methods: {
      async loadData(noLoadingAnimation = false) {
        if (this.loading) {
          return;
        }

        this.error = false;
        if (!noLoadingAnimation) {
          this.loading = true;
          this.data = [];
        }

        try {
          const response = await this.$api.post('RoomsList');
          this.data = response.data;

        } catch (error) {
          this.error = true;
        }
        this.loading = false;
      },

      _back() {
        this.$router.replace(routeOptions({path: '/share'}));
      },

      _onRoomsUpdated() {
        if (!this.dialogOpened) {
          return;
        }
        clearTimeout(this._onRooms_timeoutUpdated);
        this._onRooms_timeoutUpdated = setTimeout(() => {
          const NO_LOADING_ANIMATION = true;
          this.loadData(NO_LOADING_ANIMATION);
        }, 200);
      }
    }
  };
</script>
